<template>
  <div class="Company_honor">
    <p class="title">公司荣誉</p>
    <div class="honor-items">
      <div class="honor-item" v-for="(item,index) in honors" :key="item.name">
        <img class="honor-img" :src="item.img" alt="">
        <p class="honor-name">{{item.name}}</p>
      </div>
    </div>
    <div class="honor-items">
      <div class="honor-item" v-for="(item,index) in honors1" :key="item.name">
        <img class="honor-img1" :src="item.img" alt="">
        <p class="honor-name">{{item.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyHonor',
  data () {
    return {
      honors: [
        {img: require("@/assets/imgs/img-honor1.png"),name:'高新技术企业'},
        {img: require("@/assets/imgs/img-honor2.png"),name:'苏州市服务业领军企业'},
        {img: require("@/assets/imgs/img-honor3.png"),name:'苏州市保险数字化运营用户智能管理平台工程技术研究中心'},
      ],
      honors1: [
        {img: require("@/assets/imgs/img-honor4.png"),name:'质量管理体系认证证书'},
        {img: require("@/assets/imgs/img-honor5.png"),name:'增值电信业务经营许可证'},
        {img: require("@/assets/imgs/img-honor6.png"),name:'信息安全管理体系认证证书'},
      ],
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .Company_honor {
    width: 100%;
    // height: 400px;
    position: relative;
    background: rgba(244,244,244,1);
    padding: 40px 0;
    .title {
      height:50px;
      font-size:40px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(0,0,0,1);
      text-align: center;
      margin-bottom: 60px;
    }
    .honor-items {
      width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .honor-item {
        width: 33%;
        text-align: center;
        margin-bottom: 20px;
        .honor-img {
          height: 150px;
        }
        .honor-img1 {
          height: 320px;
        }
        .honor-name {
          width: 220px;
          margin: 5px auto;
          font-weight: 500;
          line-height: 25px;
          font-size: 16px;
          letter-spacing: 1px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Home/CompanyHonor.vue